import Color from "../../styles/export.module.scss";

export default Color;
